import { useEffect, useState } from 'react'
import { Button, Result } from 'antd'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { authApi } from '@/api/auth'

export default function AcceptInvitationPage() {
  const [params] = useSearchParams()
  const navigate = useNavigate()
  const [state, setState] = useState<'loading' | 'success' | 'error'>('loading')
  const [error, setError] = useState('')

  useEffect(() => {
    const token = params.get('token')
    if (!token) {
      setError('邀请链接缺少 token')
      setState('error')
      return
    }
    authApi.acceptInvitation(token)
      .then(() => setState('success'))
      .catch((reason) => {
        setError(reason instanceof Error ? reason.message : '接受邀请失败')
        setState('error')
      })
  }, [params])

  if (state === 'loading') return <Result status="info" title="正在接受邀请…" />
  if (state === 'error') {
    return <Result status="error" title="无法接受邀请" subTitle={error} extra={<Button onClick={() => navigate('/')}>返回</Button>} />
  }
  return <Result status="success" title="已加入企业" extra={<Button type="primary" onClick={() => window.location.assign('/')}>进入系统</Button>} />
}
